<template>
    <div id="ot-sdk-cookie-policy"></div>
</template>

<script setup lang="ts"></script>

<style scoped lang="postcss"></style>
